/**
 * @doc directive
 * @id GraphComment:writeComment
 *
 * @description this is a directive where you type a message and send it
 */
angular.module('GraphCommentModule')
.controller('WriteCommentController', [
'$scope',
'$rootScope',
'$element',
'$window',
'$log',
'$timeout',
'$document',
'$filter',
'$sce',
'GcUser',
'CommentService',
'EmoticonService',
'EmbedService',
'WriteCommentFormatHandler',
'LocalStorageService',
'SelectionCoordinate',
'Utils',
'API_URL',
'TMP_ID',
function ($scope, $rootScope, $element, $window, $log, $timeout,$document, $filter, $sce,
          GcUser, CommentService,EmoticonService, EmbedService, WriteCommentFormatHandler,LocalStorageService, SelectionCoordinate, Utils, API_URL, TMP_ID) {

  'use strict';

  $scope.GcUser = GcUser;
  $scope.moment = moment;
  $scope.CommentService = CommentService;

  $scope.trackingSent = false;
  $scope.embeds = [];
  $scope.embedBatchId = 0;
  $scope.oldEmbedUrlsDetected = [];

  $scope.isMobile = Utils.isMobile();

  if (!$scope.comment) {
    $scope.comment = { content: '' };
  } else if ($scope.comment.editing) {
    $scope.comment.content = (
      LocalStorageService.getItem('comment_' + $scope.comment._id) ||
      $filter('commentImages')($scope.comment.content)
    );
  }

  setAdminBoost();

  function setAdminBoost() {
    if (GcUser.hasPrivileges()) {
      $scope.comment.admin_boost = LocalStorageService.getItem('admin_boost');

      // boost is true by default
      if (typeof $scope.comment.admin_boost === 'undefined') {
        $scope.comment.admin_boost = true;
      }
    } else {
      $scope.comment.admin_boost = false;
    }
  }

  $rootScope.$on('logged_in', function () {
    var user = GcUser.getUser();
    if (user) {
      $scope.comment.author = { _id: user._id };
    }

    setAdminBoost();
  });

  $rootScope.$on('thread', function () {
    if (!$scope.parentComment && !$scope.comment.content) {
      $scope.comment.content = LocalStorageService.getItem('new_comment_' + CommentService.thread_id);
    }
  });

  $rootScope.$on('lang:change', function(event, lang) {
    var urls = {
      fr: 'https://support.graphcomment.com/hc/fr/articles/360011204059-Qui-a-bloqu%C3%A9-mon-compte-ou-supprim%C3%A9-mon-commentaire-',
      en: 'https://support.graphcomment.com/hc/en-us/articles/360011204059-Who-blocked-my-account-or-deleted-removed-my-comment-'
    };

    $scope.banUrl = (lang === 'fr') ? urls.fr : urls.en;
    $scope.touUrl = (lang === 'fr') ? 'https://dev-site.graphcomment.com/fr/conditions' : 'https://dev-site.graphcomment.com/fr/conditions';
    $scope.ppUrl = (lang === 'fr') ? 'https://dev-site.graphcomment.com/fr/dpa' : 'https://dev-site.graphcomment.com/fr/dpa';
  });

  $scope.showSigninPopup = function(event) {
    // remember to post comment if redirected to login page
    CommentService.setSavedComment($scope.comment.content, $scope.parentComment);
    $rootScope.$broadcast('show:popup', { page: 'signin', target: $element[0], offset: -200 });
  };

  $scope.showSignupPopup = function(event) {
    // remember to post comment if redirected to login page
    CommentService.setSavedComment($scope.comment.content, $scope.parentComment);

    $rootScope.$broadcast('show:popup', { page: 'signup', target: $element[0], offset: -200 });
  };

  $scope.cancelEdit = function () {
    mixpanel.track('comment:cancel');
    $scope.banWarning = null;

    if ($scope.comment.editing) {
      $scope.comment.editing = false;
      $scope.comment.content = $scope.comment.initialContent;
    } else {
      $scope.comment.content = '';
    }

    if ($scope.parentComment) {
      LocalStorageService.removeItem('comment_' + $scope.parentComment._id);
    } else {
      LocalStorageService.removeItem('new_comment_' + CommentService.thread_id);
    }

    closeEmoticonPopin();
    $scope.clearEmbeds();
    $scope.close();
    $scope.commentTooLong = false;
  };

  $rootScope.$on('reset_write_comment', $scope.cancelEdit);

  $scope.isEmoticonsContainerActive = false;
  $scope.emoticonList = ['😀', '😬', '😁', '😂', '😃', '😄', '😅', '😆', '😇', '😉', '😊', '🙂', '🙃', '😋', '😌', '😍', '😘', '😗', '😙', '😚', '😜', '😝', '😛', '🤑', '🤓', '😎', '🤗', '😏', '😶', '😐', '😑', '😒', '🙄', '🤔', '😳', '😞', '😟', '😠', '😡', '😔', '😕', '🙁', '😣', '😖', '😫', '😩', '😤', '😮', '😱', '😨', '😰', '😯', '😦', '😧', '😢', '😥', '😪', '😓', '😭', '😵', '😲', '🤐', '😷', '🤒', '🤕', '😴', '😈', '\u2764\uFE0F', '👍', '👎', '💣', '🎉'];

  $scope.emoticonButtonClick = function(event) {
    event.stopPropagation();
    if ($scope.isEmoticonsContainerActive) {
      closeEmoticonPopin();
    } else {
      $scope.isEmoticonsContainerActive = true;
    }
    $scope.smartEditTooltip = false;
  };

  $document.on('click', function (event) {
    var $popin = document.querySelector('.gc-comment-emoticon-popin');
    if ($popin && !$popin.contains(event.target)) {
      closeEmoticonPopin();
    }
  });

  function closeEmoticonPopin() {
    $scope.isEmoticonsContainerActive = false;

    // disable this line for now
    // because closeEmoticonPopin() is called at each keypress
    // and it's a big performance bottleneck
    /*
    $timeout(function() {
      $scope.$apply();
    });
    */
  }

  $scope.chooseEmoticon = function(event, emoticon) {
    event.preventDefault();
    event.stopPropagation();

    var contentEditable = $element[0].querySelector('.gc-comment-textarea');

    if (EmoticonService.supportsEmoticons) {
      var node = $window.document.createTextNode(emoticon);
    } else {
      var node = EmoticonService.emoticonToImgElement(emoticon);
    }

    insertNodeAtCursor(node);

    $timeout(function() {
      $scope.writeComment();
    });
  };

  $scope.renderEmoticon = function(emoticon) {
    if (!EmoticonService.supportsEmoticons) {
      return $sce.trustAsHtml(EmoticonService.emoticonToImage(emoticon));
    }
    return emoticon;
  };

  $scope.detectBanWarning = function() {
    var user = GcUser.getUser();
    var guest = GcUser.getGuest();
    $scope.isTemporaryBan = false;
    
    if (user && user.is_ban) {
      $scope.banWarning = user.ban[0];
      $scope.isTemporaryBan = !user.ban[0].temporary;

      $scope.closeBanWarning = function() {
        $scope.banWarning = null;
      };
    } else if (guest) {
      GcUser.isGuestBanned().success(function(bans) {
        var ban = bans[0];
        if (ban && ban.active && !ban.shadow) $scope.banWarning = ban;
      });
    } else {
      $scope.banWarning = null;
    }
  };

  $scope.getBanMessage = function(type) {
    var website = CommentService.website;
    if (website.moderation_content && website.moderation_content.active) {
      return website.moderation_content[type];
    }
    return type + ' banned message';
  };

  $scope.writeComment = function () {
    // This function is called only once every 300ms as specified in the template:
    // ng-model-options="{debounce: 300}"

    $scope.detectBanWarning();

    if ($scope.trackingSent === false) {
      mixpanel.track('comment:is_writting');
      $scope.trackingSent = true;
    }

    //LocalStorage comments
    if ($scope.comment.editing) {
      LocalStorageService.setItem('comment_edit_' + $scope.comment._id, $scope.comment.content);
    } else if ($scope.parentComment) {
      LocalStorageService.setItem('comment_' + $scope.parentComment._id, $scope.comment.content);
    } else {
      LocalStorageService.setItem('new_comment_' + CommentService.thread_id, $scope.comment.content);
    }

    // Embeds detection
    var maxEmbedsNbr = CommentService.website.embeded_external_link;
    var newEmbedUrlsDetected = EmbedService.findEmbedables($scope, $scope.comment.content);

    // We just compare the n first items
    var oldSliced = $scope.oldEmbedUrlsDetected.slice(0, maxEmbedsNbr);
    var newSliced = newEmbedUrlsDetected.slice(0, maxEmbedsNbr);

    // Let's compare if the embeds changed (array comparison)
    if (oldSliced.length !== newSliced.length || oldSliced.some(function(value, index) { return value.url !== newSliced[index].url})) {
      $scope.clearEmbeds();
      EmbedService.loadEmbeds($scope, newSliced, maxEmbedsNbr);
    }

    $scope.oldEmbedUrlsDetected = newEmbedUrlsDetected;
  };


  // When an embed is detected in the text
  $scope.onEmbedDetected = function(json) {
    $scope.embeds.push(json.data);
  };

  /**
   * Inserts some text in the contenteditable div than moves the cursor after the text
   */
  function insertNodeAtCursor(node, containerClassName) {
    if ($window.getSelection) {
      var sel = $window.getSelection();
      var range = sel.getRangeAt(0);

      // If selection is outside of the container, return to container
      if (!parentHasClass(range.startContainer, 'gc-comment-textarea')) {
        return;
      }

      range.collapse(false);
      range.insertNode(node);

      $timeout(function() {
        range.setStartAfter(node);
        sel.removeAllRanges();
        sel.addRange(range);

        // manually update comment.content (in case we have a comment wit only one emoji)
        $element.find('.gc-comment-textarea').trigger('gc-update-value');
      });
    }
  }

  function parentHasClass(node, className) {
    if (node.className && node.className.indexOf(className) >= 0) {
      return true;
    }
    if (node.parentNode) {
      return parentHasClass(node.parentNode, className);
    }
    return false;
  }


  $scope.clearEmbeds = function() {
    $scope.embeds = [];
    $scope.oldEmbedUrlsDetected = [];

    // The batchId has to be changed each time the embeds are refreshed.
    // Otherwise, some asynchronous embed requests could be displayed on
    // the wrong comment.
    $scope.embedBatchId = Date.now();
  };

  // submit form with Cmd+Enter (like Github)
  $scope.onKeydown = function(event) {
    if (event.keyCode === 13 && event.metaKey) {
      $scope.sendComment();
    }
  };

  $scope.$on('comment:create', function (event, opt) {
    $scope.comment.content = LocalStorageService.getItem('comment_' + opt.id);
  });

  /*************************************************************************************
   * Selection
   *************************************************************************************/
  $scope.TextAreaControl = { onSelection: onTextSelected };

  /**
   *
   * @param element {Element} The element in which the text is selected
   * @param selection {Object} The selection
   * @param selection.x {Number} The position x of selection in text in px
   * @param selection.y {Number} The position y of selection in text in px
   * @param selection.width {Number} The width of the selected text in px
   * @param selection.text {Number} The selected text
   */
  function onTextSelected(element, selection) {
    if (!CommentService.website.edition.formatting) return;

    $rootScope.$broadcast('smedPopup', {
      action: 'open',
      coordinates: {
        x: selection.x + selection.width / 2,
        y: selection.y
      },
      callbacks: WriteCommentFormatHandler
    });
  }

  //$window.document.onselectionchange = function() {
  $window.document.onmouseup = function () {
    if (SelectionCoordinate.getSelectionInfos().text === '') {
      $rootScope.$broadcast('smedPopup', {action: 'close'});
    }
  };

  $window.document.onkeyup = function (event) {
    closeEmoticonPopin();

    event = event || window.event;
    var isEscape = false;
    if ('key' in event) {
      isEscape = event.key === 'Escape';
    } else {
      isEscape = event.keyCode === 27;
    }

    if (isEscape) {
      clearSelection();
    }

    if (!event.target.classList.contains('gc-smed-input')) {
      $rootScope.$broadcast('smedPopup', { action: 'close' });
    }
  };

  $scope.checkUploadLimit = function() {
    if (!CommentService.website.edition.upload) return false;

    if (!GcUser.isLocallyLogged()) {
      console.error('should be logged to upload');
      return false;
    }

    if (CommentService.website.embeded_files === 0) {
      console.error('upload is disabled');
      return false;
    }

    var nbrHostedFiles = CommentService.getNumberOfHostedFiles($scope.comment.content)
    if (nbrHostedFiles >= CommentService.website.embeded_files) {
      console.error('upload limit reached (%s max - %s already uploaded)', CommentService.website.embeded_files, nbrHostedFiles)
      return false;
    }

    return true;
  };

  $scope.paste = function (event) {
    // paste text without formatting
    event.preventDefault();

    var clipData = (event.originalEvent || event).clipboardData;
    var html = clipData.getData('text/html');
    var parser = new DOMParser();
    var doc = parser.parseFromString(html, 'text/html');

    if (!html) {
      html = (event.originalEvent || event).clipboardData.getData('text/plain');
      // This is a case where only text was copied (no file / image) so we can inject everything and be done with it
      if (html && (!clipData.files.length || !$scope.checkUploadLimit())) {
        // However this is bad: no guarantee the whole string is correctly inserted (shouldn't happen often though)
        document.execCommand('insertHTML', false, html);
        return;
      }
    }

    if (doc && doc.body) {
      doc.body.normalize();
      html = doc.body.innerHTML;
      var docWithoutImages = parser.parseFromString(html.replace(/<img[\s\S]*?>/g, ''), 'text/html');
      // this is a special case where pasting an image from a Rich Text Format document may send empty wrappers around the image
      if (!docWithoutImages.body.innerText.trim()) {
        html = '';
      }
    }

    var sanitized = html
      // remove all attributes except anchors and images
      .replace(/<(?!a|img)\s*(\w+)[^<]*?>/gm, '<$1>')
      // remove all non external images  v--< remove the ? to allow HTTPS only 
      .replace(/<img[^<]+src="(?!https?:\/\/).+"[^<]*?>/gm, '')
      // strip html comments
      .replace(/<!--[\s\S]*?-->/g, '')
      // remove styles as tags and inlines
      .replace(/<style>[\s\S]*?<\/style>/g, '')
      .replace(/style="[\s\S]*?"/g, '')
      // remove class attributes as stylesheets are trashed
      .replace(/class="[\s\S]*?"/g, '');

    sanitized && document.execCommand('insertHTML', false, sanitized);

    if (!$scope.checkUploadLimit()) return;

    if (clipData.items.length) {
      if (!$scope.checkUploadLimit()) return;
      for (var i = 0; i < clipData.items.length; i++) {
        var item = clipData.items[i];
        if (item['type'].match(/image.*/)) {
          // this is a very special case where a Rich Text Format document may send its own image along its content
          // though it does not prevent pasting a single image into the editor
          // nor does it prevent pasting only a single image copied from a Rich Text Format document
          if (html && clipData.types.indexOf('text/rtf') >= 0) return;

          event.preventDefault();
          var img = item.getAsFile();

          // upload image
          $scope.showLoader();
          CommentService.addFile(img).success(function(resp) {
            if (resp.status && resp.status === 413) {
              $scope.onUploadError(resp);
            } else {
              var img = $filter('commentImages')(`${resp._id}.${resp.metadata.extension}`) + '<br>';
              document.execCommand('insertHTML', false, img);
              $scope.hideLoader();
            }
          }).error(function(resp) {
            $scope.onUploadError(resp);
          });

          // only one upload at a time,
          // else the user can trick `website.embeded_files` limit
          // by uploading multiple files at once
          return;
        }
      }
    }
  };

  $scope.uploadFile = function(event) {
    if (!$scope.checkUploadLimit()) return;

    var files = event.target.files;
    if (files && files.length) {
      event.preventDefault();
      var file = files[0];
      // upload image
      $scope.showLoader();
      CommentService.addFile(file).success(function(resp) {
        if (resp.status && resp.status === 413) {
          $scope.onUploadError(resp);
        } else {
          $scope.addHostedFile(resp);
        }
      }).error(function(resp) {
        $scope.onUploadError(resp);
      });
    }
  };

  $scope.showLoader = function() {
    $scope.inProgress = true;
    $scope.loaderVisible = true;
  };

  $scope.hideLoader = function() {
    $scope.inProgress = false;
    $scope.loaderVisible = false;
  };

  // after a file host on graphcomment.com has been uploaded
  $scope.addHostedFile = function(resp) {
    $scope.hideLoader();
    var imgFilename = resp._id + '.' + resp.metadata.extension
    var imgSrc = API_URL + '/file/' + imgFilename;

    // fix sometimes comment.content is set to 'undefined'
    if (!$scope.comment.content) $scope.comment.content = '';
    if ($scope.comment.content !== '') $scope.comment.content += '<br>';
    $scope.comment.content += $filter('commentImages')(imgFilename) + '<br>&nbsp;';

    $timeout(function() {
      if (!Utils.iOS()) {
        placeCaretAtEnd($element[0].querySelector('.gc-comment-textarea'));
      }
    });
  };

  $scope.onUploadError = function(resp) {
    $scope.hideLoader();
    if (resp && resp.code === 'ETOOBIG') {
      alert('The file you are uploading is too big (2Mb max).');
    } else if (resp && resp.err) {
      alert(resp.err);
    } else {
      alert('There was an error with your upload.');
    }
  };

  function clearSelection() {
    if ($window.document.selection) {
      $window.document.selection.empty();
    } else if (window.getSelection) {
      $window.getSelection().removeAllRanges();
    }
  }

  /**
   * Final comment sending function.
   *
   * @param comment
   */
  function broadcastComment(comment) {
    var guest = GcUser.getGuest();
    var user = GcUser.getUser() || guest;

    var data = {
      // This tmp id will be replaced later
      _id: comment._id || TMP_ID,
      author: user._id,
      admin_boost: comment.admin_boost,
      child_comments: comment.child_comments || [],
      created_at: comment.created_at || new Date(),
      content: EmoticonService.replaceHtmlImgByUnicode(comment.content),
      comments: comment.comments || 1,
      cached_author: comment.cached_author || {
        username: user.username,
        picture: user.picture
      }
    };

    if (guest) {
      data.username = guest.username;
      data.email = guest.email;
    }

    // Attach parent_id field if its a child comment
    if ($scope.parentComment && !$scope.comment.editing) {
      data.parent_id = $scope.parentComment._id;
      var tmpParentId = $scope.parentComment._id;

      while (tmpParentId !== null && CommentService._comments.hasOwnProperty(tmpParentId) &&
      typeof CommentService._comments[tmpParentId] !== 'undefined') {

        CommentService._comments[tmpParentId].comments += 1;

        if (CommentService._comments[tmpParentId].parent_id) {
          tmpParentId = CommentService._comments[tmpParentId].parent_id;
        } else {
          tmpParentId = null;
        }
      }
    }

    $scope.submitted({ message: data })
      .success(function (cmt) {
        if ($scope.comment.editing) {
          $scope.comment.editing = false;
        } else {
          $scope.comment.content = '';
        }

        LocalStorageService.removeItem('comment_edit_' + $scope.comment._id);
        $scope.hideLoader();
        $scope.clearEmbeds();
        $rootScope.$broadcast('textarea:update');
        $rootScope.$broadcast('smedPopup', {action: 'close'});

        $rootScope.lastCommentRead = cmt._id;
        LocalStorageService.setItem('last_comment_read_' + CommentService.thread_id, cmt._id);

        if (!$scope.parentComment) {
          CommentService.commentsAdded = 0;
        }

        CommentService.total_comments++;

        // If we are on answer message mode
        if ($scope.parentComment && !$scope.comment.editing) {
          var user = GcUser.getUser();

          // If user is logged and is not the author and has not voted, show vote
          if (user && $scope.hasVoted === 'false' && (
            $scope.parentComment.author && $scope.parentComment.author._id !== GcUser.getUser()._id ||
            $scope.parentComment.guest
          )) {
            $rootScope.votePopin = {
              comment: $scope.parentComment,
              required: true,
            };

            // in case we're inside bbf3d and we write a new comment at the very bottom
            if ($scope.bbf3d) {
              $timeout(function() {
                $rootScope.$emit('scrollTo', $('.gc-vote').offset().top - 50);
              }, 500);
            }

            var unbindWhenVoted = $rootScope.$on('comment:voted', function () {
              final_send();
              unbindWhenVoted();
            });

            var unbindVoteCancel = $rootScope.$on('vote:cancel', function() {
              unbindVoteCancel();
              unbindWhenVoted();
              $scope.hideLoader();
            });

            return false;
          }
        }
      })
      .error(function (resp) {
        $scope.hideLoader();
        if (resp.err) {
          if (resp.err === 'comment too long') {
            $scope.commentTooLong = true;
          }
          else if (resp.err === 'user is banned') {
            if (GcUser.getUser()) {
              GcUser.refresh(function() {
                $scope.detectBanWarning();
              });
            } else {
              $scope.detectBanWarning();
            }
          }
          else if (resp.err === 'profile is deleted' && CommentService.website.custom_client === 'orange') {
            $rootScope.spupLog('[spup] spup "profile is deleted"');
            var website = CommentService.website;
            if(website.custom_client_login === true) {
              //window.parent.oSpup.manage();
              window.parent.postMessage({"target": "spup", "command": "manage", "params": []}, '*');
            }
          }
          else if (resp.err === 'profile required') {
            $rootScope.$broadcast('profile-popin:open', GcUser.getUser()._id, { fromMenu: true });
          }
        }
        if (resp.msg) {
          if (resp.msg === 'route need authentication') {
            if (CommentService.website.custom_client === 'orange') {
              $rootScope.spupLog('[spup] route need authentication');
              GcUser.registerSpup($rootScope.orangeUser);
              var unbind = $rootScope.$on('spup_registered', function() {
                $rootScope.spupLog('[spup] route need authentication ... done');
                broadcastComment(comment);
                unbind();
              });
            }
          }
        }
      });
    ;
  }

  /**
   * Sub-function for comments submitting.
   *
   * @return {boolean}
   */
  $scope.commentPushWhileNotLogged = [];
  function final_send() {
    
    // If user is not logged show popup
    if (!GcUser.isLocallyLogged() && (!CommentService.website.guest || !GcUser.getGuest())) {
      $log.debug('User not logged.');

      // remember to post comment if redirected to login page
      CommentService.setSavedComment($scope.comment.content, $scope.parentComment);

      if ($rootScope.ssoUnidirectionalEnabled()) {
        $scope.hideLoader();
      }

      // Send message to GcAuth
      $rootScope.$broadcast('show:popup', { page: 'signup', target: $element[0], offset: -200 });

      var a = $rootScope.$on('logged_in', function (unused, user) {
        CommentService.removeSavedComment();

        // Update parent that was just changed by $rootScope.$on('read:refresh', ...)
        if ($scope.parentComment) {
          $scope.parentComment = CommentService._comments[$scope.parentComment._id];
        }

        if (typeof $scope.parentComment === 'object' && $scope.parentComment.rating.has_voted === true) {
          broadcastComment($scope.commentPushWhileNotLogged[$scope.commentPushWhileNotLogged.length - 1]);
          return;
        }

        if (GcUser.isGuest()) {
          broadcastComment($scope.commentPushWhileNotLogged[$scope.commentPushWhileNotLogged.length - 1]);
          return;
        }

        if ($scope.commentPushWhileNotLogged.length > 0) {
          broadcastComment($scope.commentPushWhileNotLogged[$scope.commentPushWhileNotLogged.length - 1]);
        }
        // We just connect, so we can put this var to empty tab
        $scope.commentPushWhileNotLogged = [];

        // Un-register the event listening
        a();
      });

      var unbind = $rootScope.$on('auth:cancel', function() {
        unbind();
        $scope.hideLoader();
      });

      return false;
    }

    if ($scope.commentPushWhileNotLogged.length > 0) {
      broadcastComment($scope.commentPushWhileNotLogged[$scope.commentPushWhileNotLogged.length - 1]);
    }

    // We just connect, so we can put this var to empty tab
    $scope.commentPushWhileNotLogged = [];
    return false;
  };

  /**
   * Check if a user can write a comment (is not banned)
   */
  $scope.canWriteComment = function() {
    var user = GcUser.getUser();
    return !user || !user.is_ban || user.ban.find( b => b.hide_ban_message);
  };


  $scope.toggleAdminBoost = function() {
    $scope.comment.admin_boost = !$scope.comment.admin_boost;
    LocalStorageService.setItem('admin_boost', $scope.comment.admin_boost);
  };

  /**
   * Submits the comment to the API.
   *
   * @return {*}
   */
  $scope.sendComment = function sendComment() {
    
    // make sure content is up to date (can be out of date when adding emojis)
    $scope.comment.content = $element.find('.gc-comment-textarea').html();
    if($scope.comment.content.length > CommentService.website.graphcomment.length_comment) return
    $scope.commentTooLong = false;
    $scope.detectBanWarning();

    if (CommentService.website.custom_client === 'orange') {
      $rootScope.spupLog('[spup] sendComment() init spup');
      var isRegistered = GcUser.initSpup(sendComment);

      function reset() {
        $scope.hideLoader();
        CommentService.removeSavedComment();
      }

      var unbind = $rootScope.$on('call_reset_spup_comment', function() {
        $rootScope.spupLog('[spup] sendComment() init spup ... done');
        reset();
        unbind();
      });

      if (!isRegistered) {
        $scope.showLoader();
        return;
      }

      reset();
    }

    if (!$scope.canWriteComment()) return;
    $scope.showLoader();

    if ($scope.parentComment) {
      LocalStorageService.removeItem('comment_' + $scope.parentComment._id);
    } else {
      LocalStorageService.removeItem('new_comment_' + CommentService.thread_id);
    }

    var tmp_cmt = JSON.parse(JSON.stringify($scope.comment));
    $scope.commentPushWhileNotLogged.push(tmp_cmt);

    return final_send();
  };
  
  $scope.openGuestForm = function() {
    $scope.guest = {};
    $scope.showGuestForm = true;
    $scope.errorValidationCGU = false;
    // $timeout(function () {
    //   window.grecaptcha.render(document.querySelector('.gc-comment-submit-captcha'), {
    //     badge: 'bottomleft',
    //   });
    // });
  };

  $scope.closeGuestForm = function() {
    $scope.guest = {};
    $scope.showGuestForm = false;
    // $('.grecaptcha-badge').parent().remove();
  };

  $scope.forms = {};
  $scope.sendCommentAsGuest = function() {
    // google recaptch is hijacking button's disabled attribute
    // so we add validation here
    if($scope.forms.fCommentGuest.validateCGU.$invalid) $scope.errorValidationCGU = true;
    if ($scope.forms.fCommentGuest && $scope.forms.fCommentGuest.$invalid) {
      
      console.error('[gc] invalid guest form', $scope.forms.fCommentGuest)
      return;
    }

    GcUser.setGuest({
      username: $scope.guest.username,
      email: $scope.guest.email,
    });

    mixpanel.track('auth:guest_success');

    $scope.sendComment();
    $scope.closeGuestForm();
  };

  //window.onCommentGuestFormSubmit = $scope.sendCommentAsGuest.bind($scope);

}])
.directive('writeComment', ['$rootScope', 'Utils', function ($rootScope, Utils) {
  'use strict';
  return {
    restrict: 'E',
    replace: true,
    scope: {
      active: '@',
      bbf3d: '@?',
      submitted: '&',
      comment: '=?',
      parentComment: '=?',
      disableAutoFocus: '@',
      close: '&',
      hasVoted: '@',
      rating: '='
    },
    controller: 'WriteCommentController',
    templateUrl: 'write_comment.html',
    link: function (scope, el) {

      setTimeout(function () {
        var contentEditable = el[0].querySelector('.gc-comment-textarea');

        if (scope.comment.editing) {
          if (!Utils.iOS()) {
            placeCaretAtEnd(contentEditable);
          }
        }
        else if (scope.parentComment) {
          // There is an iOS bug on focus, so we detect iOS here
          // http://stackoverflow.com/questions/40487279/calling-element-focus-in-iframe-scrolls-parent-page-to-random-position-in-safa
          if (!Utils.iOS() && !scope.disableAutoFocus) {
            contentEditable.focus();
          }
        }
      }, 10);
    }
  };
}])
.service('WriteCommentFormatHandler', [
'$document',
'$window',
'SelectionCoordinate',
function ($document, $window, SelectionCoordinate) {
  'use strict';

  this.bold = function (popupControl) {
    $document[0].execCommand('bold', false, null);
    popupControl.close();
  };

  this.italic = function (popupControl) {
    $document[0].execCommand('italic', false, null);
    popupControl.close();
  };

  this.underline = function (popupControl) {
    $document[0].execCommand('underline', false, null);
    popupControl.close();
  };

  this.code = function (popupControl) {
    var selection = SelectionCoordinate.getSelectionInfos().text;
    // wrap with `
    if (!/^`/.test(selection)) {
      if (selection.match(/\n/g) || selection.length > 40) {
        var wrapped = '```<br>' + selection.replace(/\n/g, '<br>') + '<br>```';
      } else {
        var wrapped = '`' + selection + '`';
      }
    }
    // un-wrap with `
    else {
      var wrapped = selection.replace(/^[`]+(.*[^`])[`]+$/, '$1');
    }
    $document[0].execCommand('insertHTML', false, wrapped);
    popupControl.close();
  };

  this.link = function (popupControl, href) {
    $document[0].execCommand('CreateLink', false, href);
    var linkNode = $window.getSelection().focusNode.parentNode;
    var linkEl = angular.element(linkNode);

    linkEl.addClass('gc-link');
    linkEl.attr('target', '_blank');
    linkEl.attr('rel', 'nofollow');

    popupControl.close();
  };

}]);


// place caret at end of a contenteditable el
// https://stackoverflow.com/a/4238971
function placeCaretAtEnd(el) {
  el.focus();
  if (typeof window.getSelection != "undefined"
      && typeof document.createRange != "undefined") {
        var range = document.createRange();
        range.selectNodeContents(el);
        range.collapse(false);
        var sel = window.getSelection();
        sel.removeAllRanges();
        sel.addRange(range);
      } else if (typeof document.body.createTextRange != "undefined") {
        var textRange = document.body.createTextRange();
        textRange.moveToElementText(el);
        textRange.collapse(false);
        textRange.select();
      }
}

// setting the caret with this info  is also standard
function setCaretPosition(d){
  var sel = window.getSelection();
  var range = document.createRange();
  range.setStart(d.node, d.position);
  range.collapse(true);
  sel.removeAllRanges();
  sel.addRange(range);
}

